export var VALID_CODE_LENGTH = 6;
export var isNumericOrBlank = function(value) {
    return !isNaN(parseFloat(value)) || value === "";
};
export var isNumericOrBlankCode = function(code) {
    return Array.from(code).every(function(slot) {
        return isNumericOrBlank(slot);
    });
};
